<template>
    <base-side-bar
        ><div
            class="flex flex-col items-center justify-center flex-grow w-full mx-10"
        >
            <h2
                class="font-extrabold leading-9 text-center text-blue-600 text-xxxl sm:text-xl sm:leading-10"
            >
                Moyens humains
            </h2>
            <br />
            <div
                class="flex flex-col items-center justify-center flex-grow w-full"
            >
                <!--  <wide-card>
                    <base-tips-alert>
                        <p class="my-0 mt-1 text-gray-700">
                            Veillez à ne pas « sous-dimensionner » ou «
                            sur-dimensionner » votre projet sur le plan moyens
                            humains.
                        </p>
                    </base-tips-alert>
                </wide-card> -->
                <div
                    class="flex items-center w-full px-4 py-6 mb-4 bg-white border border-gray-200 shadow-sm rounded-"
                >
                    <div class="w-full px-4 mx-auto sm:px-6 lg:px-8">
                        <div class="max-w-4xl mx-auto">
                            <label
                                class="block my-2 mb-2 text-sm font-normal leading-5 tracking-wide text-gray-600 sm:font-normal sm:text-base sm:leading-10"
                                >Moyens Humains</label
                            >
                            <multiselect
                                v-model="labours"
                                tag-placeholder="Add this as new tag"
                                placeholder="Search or add a tag"
                                label="name"
                                track-by="code"
                                :options="options"
                                :multiple="true"
                                :taggable="true"
                                @tag="addTag"
                            ></multiselect>
                            <template
                                v-if="
                                    labours.length !== 0 && isSimplifiedVersion
                                "
                            >
                                <div
                                    v-for="(labour, index) in labours"
                                    :key="labour.code"
                                >
                                    <label
                                        class="block my-2 text-sm font-semibold leading-5 tracking-wide text-gray-600 sm:semibold sm:text-base sm:leading-10"
                                        >{{ labour.name }}</label
                                    >
                                    <div class="flex -mt-6">
                                        <base-number-input
                                            label="Effectif"
                                            v-model="labour.value"
                                            :hasError="
                                                $v.labours[`${index}`].$error
                                            "
                                            :errorMessage="
                                                errorMessage(
                                                    labour.name,
                                                    $v.labours[`${index}`].value
                                                )
                                            "
                                            @blur="
                                                $v.labours[
                                                    `${index}`
                                                ].value.$touch()
                                            "
                                        />
                                        <base-number-input
                                            label="Salaire mensuel (brut)"
                                            v-model="labour.salary"
                                            :isCurrency="true"
                                            :hasError="
                                                $v.labours[`${index}`].$error
                                            "
                                            :errorMessage="
                                                errorMessage(
                                                    labour.name,
                                                    $v.labours[`${index}`]
                                                        .salary
                                                )
                                            "
                                            @blur="
                                                $v.labours[
                                                    `${index}`
                                                ].salary.$touch()
                                            "
                                        /><base-number-input
                                            label="Nombre de mois"
                                            v-model="labour.monthNumber"
                                            :hasError="
                                                $v.labours[`${index}`].$error
                                            "
                                            :errorMessage="
                                                errorMessage(
                                                    labour.name,
                                                    $v.labours[`${index}`]
                                                        .monthNumber
                                                )
                                            "
                                            @blur="
                                                $v.labours[
                                                    `${index}`
                                                ].monthNumber.$touch()
                                            "
                                        />
                                    </div>
                                </div>
                            </template>
                            <div v-if="labours && !isSimplifiedVersion">
                                <base-number-input
                                    v-for="(labour, index) in labours"
                                    :key="index"
                                    :label="getLabel(labour.name)"
                                    v-model="labour.value"
                                    :hasError="$v.labours[`${index}`].$error"
                                    :errorMessage="
                                        errorMessage(
                                            labour.name,
                                            $v.labours[`${index}`].value
                                        )
                                    "
                                    @blur="
                                        $v.labours[`${index}`].value.$touch()
                                    "
                                />

                                <div class="flex justify-end mt-4 mr-6"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <base-primary-button title="Suivant" @click="nextStep" />
            </div></div
    ></base-side-bar>
</template>

<script>
import WideCard from "../../../components/cards/wideCard";
import { mapState, mapGetters } from "vuex";
import {
    required,
    integer,
    minValue,
    maxValue
} from "vuelidate/lib/validators";
import { errorMessage } from "@/mixins/errorMessage.js";
import { scrollToError } from "@/mixins/scrollToMixin.js";

export default {
    components: {
        WideCard
    },
    props: {
        title: {
            type: String
        }
    },
    mixins: [errorMessage, scrollToError],
    validations() {
        if (this.labours.length !== 0) {
            let array = this.labours.map((element, index) => {
                if (!this.isSimplifiedVersion)
                    return {
                        [`${index}`]: {
                            value: { required, integer, minValue: minValue(1) }
                        }
                    };
                return {
                    [`${index}`]: {
                        value: { required, integer, minValue: minValue(1) },
                        salary: { required, integer, minValue: minValue(1) },
                        monthNumber: {
                            required,
                            integer,
                            minValue: minValue(1),
                            maxValue: maxValue(12)
                        }
                    }
                };
            });

            let validation = {
                ...Object.assign({}, {}, ...array)
            };
            return { labours: validation };
        }
        return {};
    },
    created() {
        this.labours = this.$store.getters["EtudeTechnique/getLabourCard"];
        this.$store.dispatch("forms/showSection", "Étude Technique");
        this.$store.dispatch("forms/stepFocus", "Moyens humains");
    },
    data() {
        return {
            labours: []
        };
    },
    methods: {
        nextStep() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.$store.dispatch(
                    "EtudeTechnique/addLabourCard",
                    this.labours
                );
                this.$store.dispatch("EtudeTechnique/SaveLabours");
                this.$store.dispatch("forms/subStepComplete", "Moyens humains");
                this.$router.push({
                    name: "success_message3",
                    params: { uid: `${this.$store.state.user.bpiId}` }
                });
                /*
        this.$router.push({
          name: "programme_dinvestissement_plan_de_financement",
        });
        */
            } else {
                this.scrollToError();

                this.$emit("showNotification", {
                    error: true,
                    content:
                        "Une erreur a été détectée, veuillez revérifier les informations remplies.",
                    title: "Attention"
                });
            }
        },
        addTag(newTag) {
            const tag = {
                name: newTag,
                code: new Date().getTime(),
                value: null,
                salary: null,
                monthNumber: 12
            };
            this.options.push(tag);
            this.labours.push(tag);
        },

        addLabourCard() {
            this.$store.dispatch("EtudeTechnique/addLabourCard", this.labours);
        }
    },
    computed: {
        ...mapGetters("user", {
            isSimplifiedVersion: "isSimplifiedVersion"
        }),
        ...mapState("forms", {
            options: state => state.labourCard.options
        }),
        getLabel() {
            return label => "Effectif " + label + ":";
        }
    }
};
</script>

<style></style>
